import type { ImportAdapter } from '../types';
import { createZipImportAdapter } from './zip-import.adapter';

// =============================================================================
// TEMPLATE IMPORT ADAPTER
// =============================================================================

/**
 * Template Import Adapter
 *
 * Handles import of email/SMS templates from ZIP files.
 * Uses the shared ZIP import adapter factory for common functionality.
 *
 * Flow:
 * 1. User uploads a ZIP file containing templates
 * 2. System calls describe-file API to list available templates
 * 3. User selects which templates to import
 * 4. System imports selected templates
 */
const baseAdapter = createZipImportAdapter({
  type: 'template',
  emptyFileErrorKey: 'import.itemSelector.noTemplatesFound',
});

export const templateAdapter: ImportAdapter = {
  ...baseAdapter,
  processingMode: 'immediate',
};

export default templateAdapter;
